import {useMemo, useState} from 'react';
import {downloadCSVFiles, getDateWithTimeString} from '@/helpers/shadcn/utils';
import {useDataTable} from '@/hooks/useDataTable-hook';
import {buildQueryParams} from '@/utils/commons';
import {GetFormattedActivityData} from '@/models/ActivityListModel';
import {getActivityCsvFile, handleGetActivity} from '@/services/activities';
import {ActivitiesColConfig} from '@/services/MockData/Activity/ActivitiesColConfig';
import {useQuery, keepPreviousData} from '@tanstack/react-query';

const initialSortConfig = {
  column: ActivitiesColConfig[6].name_of_db_column,
  direction: 'desc'
};

export const useActivites = () => {
  const [pageSize, setPageSize] = useState(10);

  const {
    setPageIndex,
    setSortingObj,
    setSearchArry,
    pageIndex,
    sortingObj,
    searchArr,
    handleResetAll
  } = useDataTable(0, false, false, initialSortConfig);
  const queryParams = useMemo(() => {
    return buildQueryParams({
      ...(sortingObj?.column && {
        sortBy: sortingObj.column,
        order: sortingObj.direction
      }),
      pageSize,
      page: pageIndex || 0
    });
  }, [sortingObj?.column, sortingObj?.direction, pageIndex, pageSize]);

  const {data, isPending, isFetching, isError} = useQuery({
    queryKey: ['GET_ACTIVITY', queryParams, searchArr],
    queryFn: () => handleGetActivity(queryParams, searchArr),
    placeholderData: keepPreviousData
  });

  const onDownloadBtnClick = async (selectedIds, excludeIds = []) => {
    const body = {
      ids: selectedIds,
      excludeIds,
      filters: searchArr
    };

    const data = await getActivityCsvFile(queryParams, body);
    const fileName = `Activity_${getDateWithTimeString()}`;
    downloadCSVFiles(data, fileName);
  };

  // Sync sorting state from API response
  const resultsData = useMemo(() => data || {}, [data]);

  const activityListData = useMemo(
    () => GetFormattedActivityData(resultsData),
    [resultsData]
  );

  return {
    activityListData,
    activityLColConfigData: ActivitiesColConfig,
    pageIndex,
    setPageIndex,
    pageSize,
    setPageSize,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    handleResetAll,
    isPending,
    isFetching,
    isError
  };
};
